import { BreakpointContext } from "components/common";
import React, { useContext } from "react";
import { BoostBannerImage, CheckMark } from "@tomocredit/common-fe/components";
import Guard from "assets/guard.svg";
import TestimonialCard1 from "assets/boost/testimonial_card-1.webp";
import TestimonialCard2 from "assets/boost/testimonial_card-2.webp";
import TestimonialCard3 from "assets/boost/testimonial_card-3.webp";
import TestimonialCard4 from "assets/boost/testimonial_card-4.webp";

const BoostLanding = ({ user }) => {
  const { isBelow } = useContext(BreakpointContext);
  const belowMd = isBelow("md");
  const urlParams = `?email=${encodeURIComponent(user.email)}`;
  const pricingLink = `${process.env.REACT_APP_DOMAIN}/boost-pricing${urlParams}`;
  const landingLink = `${process.env.REACT_APP_DOMAIN}/boost${urlParams}`;
  return (
    <div
      className="bg-white relative h-full"
      style={{ letterSpacing: -0.25, lineHeight: 1.1 }}
    >
      <div
        className="px-6 md:px-10 pt-12 xl:pt-24 flex flex-col items-center justify-center mx-auto"
        style={{ maxWidth: 1010 }}
      >
        <h1 className="font-bold text-4xl md:text-5xl">
          Build Credit Fast<span className="text-boost-primary-500">.</span>
        </h1>
        <div
          className="mt-5 flex items-center text-left text-boost-price-green whitespace-pre-wrap leading-normal"
          style={{ letterSpacing: 0.1, maxWidth: belowMd ? 262 : undefined }}
        >
          <img src={Guard} alt="" className="inline mr-2 h-4" />
          <span>
            Trusted by <span className="font-bold">3.5 million+</span> people
            building credit with TomoBoost
          </span>
        </div>
        <div className="mt-6 flex flex-col justify-center items-center space-y-4 md:flex-row md:space-y-0 md:space-x-4 w-full">
          <a
            href={pricingLink}
            className="text-white hover:text-white bg-black hover:bg-neutral-600 focus:bg-neutral-700 font-medium hover:font-medium w-full text-center rounded-md flex justify-center items-center"
            style={{ maxWidth: belowMd ? undefined : 117, height: 40 }}
          >
            Get started
          </a>
          <a
            href={landingLink}
            className="bg-white hover:bg-neutral-200 focus:bg-neutral-300 font-medium hover:font-medium w-full text-center rounded-md flex justify-center items-center"
            style={{ maxWidth: belowMd ? undefined : 117, height: 40 }}
          >
            Learn more
          </a>
        </div>
        <div className="mt-10 py-12 bg-neutral-700 rounded-xl w-full flex flex-col md:flex-row justify-center items-center">
          <div style={{ maxWidth: 255, height: "auto" }}>
            <BoostBannerImage />
          </div>
          <div className="mt-6 md:mt-0 md:ml-20 text-lg flex flex-col text-white">
            <CheckMark className="my-3">
              <span className="">
                No Credit Checks. <span className="font-bold">EVER.</span>
              </span>
            </CheckMark>
            <CheckMark className="my-3">
              <span className="">
                Boost Credit Score <span className="font-bold">FAST.</span>
              </span>
            </CheckMark>
            <CheckMark className="my-3">
              <span className="relative">
                <span>Raise Score </span>
                <span className="font-bold">100+</span>
                <span> points.</span>
              </span>
            </CheckMark>
          </div>
        </div>
      </div>
      <div className="mt-2 pb-12 mx-auto" style={{ maxWidth: 1010 }}>
        <div className="flex overflow-x-scroll hide-x-scrollbar shrink-0 w-full">
          <div className="px-6 md:px-10 pt-4 pb-10 space-x-4 flex self-start overflow-visible">
            {[
              TestimonialCard1,
              TestimonialCard2,
              TestimonialCard3,
              TestimonialCard4,
            ].map((card, idx) => (
              // <div className="">
              <img
                alt=""
                // eslint-disable-next-line react/no-array-index-key
                key={`TestimonialCard-${idx}`}
                src={card}
                // eslint-disable-next-line no-nested-ternary
                className={`box-content transform hover:scale-110 transition-transform ${
                  idx === 3 ? (belowMd ? "pr-6" : "pr-10") : ""
                }`}
                style={{ width: belowMd ? 267 : 219, height: "auto" }}
              />
              // </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoostLanding;
